module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 6);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /*---------------- Load All -------------------*/

  var LOAD_PUBLISHED_CONTENT_REQUEST = exports.LOAD_PUBLISHED_CONTENT_REQUEST = 'LOAD_PUBLISHED_CONTENT_REQUEST';
  var LOAD_PUBLISHED_CONTENT_SUCCESS = exports.LOAD_PUBLISHED_CONTENT_SUCCESS = 'LOAD_PUBLISHED_CONTENT_SUCCESS';
  var LOAD_PUBLISHED_CONTENT_FAILURE = exports.LOAD_PUBLISHED_CONTENT_FAILURE = 'LOAD_PUBLISHED_CONTENT_FAILURE';
  /*---------------- Load Pending -------------------*/

  var LOAD_PENDING_CONTENT_REQUEST = exports.LOAD_PENDING_CONTENT_REQUEST = 'LOAD_PENDING_CONTENT_REQUEST';
  var LOAD_PENDING_CONTENT_SUCCESS = exports.LOAD_PENDING_CONTENT_SUCCESS = 'LOAD_PENDING_CONTENT_SUCCESS';
  var LOAD_PENDING_CONTENT_FAILURE = exports.LOAD_PENDING_CONTENT_FAILURE = 'LOAD_PENDING_CONTENT_FAILURE';
  /*---------------- Edit -------------------*/

  var EDIT_CONTENT_REQUEST = exports.EDIT_CONTENT_REQUEST = 'EDIT_CONTENT_REQUEST';
  var EDIT_CONTENT_SUCCESS = exports.EDIT_CONTENT_SUCCESS = 'EDIT_CONTENT_SUCCESS';
  var EDIT_CONTENT_FAILURE = exports.EDIT_CONTENT_FAILURE = 'EDIT_CONTENT_FAILURE';
  /*---------------- Save -------------------*/

  var SAVE_CONTENT_REQUEST = exports.SAVE_CONTENT_REQUEST = 'SAVE_CONTENT_REQUEST';
  var SAVE_CONTENT_SUCCESS = exports.SAVE_CONTENT_SUCCESS = 'SAVE_CONTENT_SUCCESS';
  var SAVE_CONTENT_FAILURE = exports.SAVE_CONTENT_FAILURE = 'SAVE_CONTENT_FAILURE';
  /*---------------- Commit -------------------*/

  var COMMIT_CONTENT_REQUEST = exports.COMMIT_CONTENT_REQUEST = 'COMMIT_CONTENT_REQUEST';
  var COMMIT_CONTENT_SUCCESS = exports.COMMIT_CONTENT_SUCCESS = 'COMMIT_CONTENT_SUCCESS';
  var COMMIT_CONTENT_FAILURE = exports.COMMIT_CONTENT_FAILURE = 'COMMIT_CONTENT_FAILURE';
  /*---------------- Push -------------------*/

  var PUSH_CONTENT_REQUEST = exports.PUSH_CONTENT_REQUEST = 'PUSH_CONTENT_REQUEST';
  var PUSH_CONTENT_SUCCESS = exports.PUSH_CONTENT_SUCCESS = 'PUSH_CONTENT_SUCCESS';
  var PUSH_CONTENT_FAILURE = exports.PUSH_CONTENT_FAILURE = 'PUSH_CONTENT_FAILURE';
  /*---------------- Edit Mode -------------------*/

  var EDIT_MODE_CONTENT_REQUEST = exports.EDIT_MODE_CONTENT_REQUEST = 'EDIT_MODE_CONTENT_REQUEST';
  var EDIT_MODE_CONTENT_SUCCESS = exports.EDIT_MODE_CONTENT_SUCCESS = 'EDIT_MODE_CONTENT_SUCCESS';
  /*---------------- Delete Mode -------------------*/

  var DELETE_CONTENT_REQUEST = exports.DELETE_CONTENT_REQUEST = 'DELETE_CONTENT_REQUEST';
  var DELETE_CONTENT_FAILURE = exports.DELETE_CONTENT_FAILURE = 'DELETE_CONTENT_FAILURE';
  var DELETE_CONTENT_SUCCESS = exports.DELETE_CONTENT_SUCCESS = 'DELETE_CONTENT_SUCCESS';
  /*---------------- Show Origin -------------------*/

  var SHOW_ORIGIN = exports.SHOW_ORIGIN = 'SHOW_ORIGIN';
  /*----------------History -------------------*/

  var HISTORY_REQUEST = exports.HISTORY_REQUEST = 'HISTORY_REQUEST';
  var HISTORY_FAILURE = exports.HISTORY_FAILURE = 'HISTORY_FAILURE';
  var HISTORY_SUCCESS = exports.HISTORY_SUCCESS = 'HISTORY_SUCCESS';
  /*----------------History Detail -------------------*/

  var HISTORY_DETAIL_REQUEST = exports.HISTORY_DETAIL_REQUEST = 'HISTORY_DETAIL_REQUEST';
  var HISTORY_DETAIL_FAILURE = exports.HISTORY_DETAIL_FAILURE = 'HISTORY_DETAIL_FAILURE';
  var HISTORY_DETAIL_SUCCESS = exports.HISTORY_DETAIL_SUCCESS = 'HISTORY_DETAIL_SUCCESS';
  var HISTORY_DETAIL_RESET = exports.HISTORY_DETAIL_RESET = 'HISTORY_DETAIL_RESET';
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _cmsActions = __webpack_require__(4);

  var cmsActions = _interopRequireWildcard(_cmsActions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, cmsActions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$cmsDefinition = state.cmsDefinition,
        cmsDefinition = _state$cmsDefinition === undefined ? {} : _state$cmsDefinition;
    var publishedContent = cmsDefinition.publishedContent,
        pendingContent = cmsDefinition.pendingContent,
        savedPendingContent = cmsDefinition.savedPendingContent,
        contentEdited = cmsDefinition.contentEdited,
        tagEdited = cmsDefinition.tagEdited,
        contentSaved = cmsDefinition.contentSaved,
        contentCommitted = cmsDefinition.contentCommitted,
        contentPushed = cmsDefinition.contentPushed,
        inEditMode = cmsDefinition.inEditMode,
        referrer = cmsDefinition.referrer,
        isFetching = cmsDefinition.isFetching,
        showOrigin = cmsDefinition.showOrigin,
        historyList = cmsDefinition.historyList,
        historyDetail = cmsDefinition.historyDetail,
        _cmsDefinition$error = cmsDefinition.error,
        error = _cmsDefinition$error === undefined ? null : _cmsDefinition$error;
    return {
      publishedContent: publishedContent,
      pendingContent: pendingContent,
      savedPendingContent: savedPendingContent,
      contentEdited: contentEdited,
      tagEdited: tagEdited,
      contentSaved: contentSaved,
      contentCommitted: contentCommitted,
      contentPushed: contentPushed,
      inEditMode: inEditMode,
      referrer: referrer,
      isFetching: isFetching,
      showOrigin: showOrigin,
      historyList: historyList,
      historyDetail: historyDetail,
      error: error
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _cmsDefinition = __webpack_require__(5);

  var _cmsDefinition2 = _interopRequireDefault(_cmsDefinition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var cmsDefinition = function cmsDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var newState = state;
    newState = (0, _cmsDefinition2.default)(newState, action);
    return newState;
  };

  exports.default = cmsDefinition;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.resetHistoryDetail = exports.fetchHistoryDetail = exports.historyDetailSuccess = exports.historyDetailFailed = exports.historyDetailRequest = exports.fetchHistoryList = exports.historyListSuccess = exports.historyListFailed = exports.historyListRequest = exports.setEditMode = exports.setShowOrigin = exports.contentEditModeSuccess = exports.contentEditModeRequest = exports.deleteContent = exports.deleteContentSuccess = exports.deleteContentFailed = exports.deleteContentRequest = exports.pushContent = exports.pushContentSuccess = exports.pushContentFailed = exports.pushContentRequest = exports.commitContent = exports.commitContentSuccess = exports.commitContentFailed = exports.commitContentRequest = exports.saveContent = exports.saveContentSuccess = exports.saveContentFailed = exports.saveContentRequest = exports.editContent = exports.editContentSuccess = exports.editContentFailed = exports.editContentRequest = exports.fetchPendingContentIfNeeded = exports.shouldFetchPendingContent = exports.loadPendingContent = exports.loadPendingContentSuccess = exports.loadPendingContentFailed = exports.loadPendingContentRequest = exports.fetchPublishedContentIfNeeded = exports.shouldFetchPublishedContent = exports.loadPublishedContent = exports.loadPublishedContentSuccess = exports.loadPublishedContentFailed = exports.loadPublishedContentRequest = undefined;

  var _interact = __webpack_require__(7);

  var _cmsActionTypes = __webpack_require__(0);

  var _immutabilityHelper = __webpack_require__(8);

  var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /*---------------- Load Published -------------------*/


  var loadPublishedContentRequest = exports.loadPublishedContentRequest = function loadPublishedContentRequest() {
    return {
      type: _cmsActionTypes.LOAD_PUBLISHED_CONTENT_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var loadPublishedContentFailed = exports.loadPublishedContentFailed = function loadPublishedContentFailed(error) {
    return {
      type: _cmsActionTypes.LOAD_PUBLISHED_CONTENT_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var loadPublishedContentSuccess = exports.loadPublishedContentSuccess = function loadPublishedContentSuccess(json) {
    return {
      type: _cmsActionTypes.LOAD_PUBLISHED_CONTENT_SUCCESS,
      publishedContent: json,
      isFetching: false,
      error: null
    };
  };

  var loadPublishedContent = exports.loadPublishedContent = function loadPublishedContent() {
    return function (dispatch) {
      dispatch(loadPublishedContentRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + 'published/', {
        method: 'get',
        headers: _interact.Connection.cmuHeaders()
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(loadPublishedContentSuccess(json));
      }).catch(function (error) {
        return dispatch(loadPublishedContentFailed(error));
      });
    };
  };

  var shouldFetchPublishedContent = exports.shouldFetchPublishedContent = function shouldFetchPublishedContent(state) {
    if (!state || !state.publishedContent) {
      return true;
    }
  };

  var fetchPublishedContentIfNeeded = exports.fetchPublishedContentIfNeeded = function fetchPublishedContentIfNeeded() {
    return function (dispatch, getState) {
      if (shouldFetchPublishedContent(getState().cmsDefinition)) {
        return dispatch(loadPublishedContent());
      }
    };
  };
  /*---------------- Load Updated -------------------*/


  var loadPendingContentRequest = exports.loadPendingContentRequest = function loadPendingContentRequest() {
    return {
      type: _cmsActionTypes.LOAD_PENDING_CONTENT_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var loadPendingContentFailed = exports.loadPendingContentFailed = function loadPendingContentFailed(error) {
    return {
      type: _cmsActionTypes.LOAD_PENDING_CONTENT_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var loadPendingContentSuccess = exports.loadPendingContentSuccess = function loadPendingContentSuccess(json) {
    return {
      type: _cmsActionTypes.LOAD_PENDING_CONTENT_SUCCESS,
      pendingContent: json,
      isFetching: false,
      error: null
    };
  };

  var loadPendingContent = exports.loadPendingContent = function loadPendingContent() {
    return function (dispatch) {
      dispatch(loadPendingContentRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + 'pending/', {
        method: 'get',
        headers: _interact.Connection.cmuHeaders()
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(loadPendingContentSuccess(json));
      }).catch(function (error) {
        return dispatch(loadPendingContentFailed(error));
      });
    };
  };

  var shouldFetchPendingContent = exports.shouldFetchPendingContent = function shouldFetchPendingContent(state) {
    if (!state || !state.pendingContent) {
      return true;
    }
  };

  var fetchPendingContentIfNeeded = exports.fetchPendingContentIfNeeded = function fetchPendingContentIfNeeded() {
    return function (dispatch, getState) {
      if (shouldFetchPendingContent(getState().cmsDefinition)) {
        return dispatch(loadPendingContent());
      }
    };
  };
  /*---------------- Edit -------------------*/


  var editContentRequest = exports.editContentRequest = function editContentRequest() {
    return {
      type: _cmsActionTypes.EDIT_CONTENT_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var editContentFailed = exports.editContentFailed = function editContentFailed(error) {
    return {
      type: _cmsActionTypes.EDIT_CONTENT_FAILURE,
      contentEdited: null,
      isFetching: false,
      error: error.message
    };
  };

  var editContentSuccess = exports.editContentSuccess = function editContentSuccess(tag, content) {
    return {
      type: _cmsActionTypes.EDIT_CONTENT_SUCCESS,
      contentEdited: content,
      tagEdited: tag,
      isFetching: false,
      error: null
    };
  };

  var editContent = exports.editContent = function editContent(tag, content) {
    return function (dispatch) {
      dispatch(editContentRequest());
      if (!tag || tag === '') dispatch(editContentFailed('component tag not found'));
      dispatch(editContentSuccess(tag, content));
    };
  };
  /*---------------- Save -------------------*/


  var saveContentRequest = exports.saveContentRequest = function saveContentRequest() {
    return {
      type: _cmsActionTypes.SAVE_CONTENT_REQUEST,
      isFetching: true,
      contentSaved: false,
      error: null
    };
  };

  var saveContentFailed = exports.saveContentFailed = function saveContentFailed(error) {
    return {
      type: _cmsActionTypes.SAVE_CONTENT_FAILURE,
      contentSaved: false,
      error: error.message
    };
  };

  var saveContentSuccess = exports.saveContentSuccess = function saveContentSuccess(json) {
    return {
      type: _cmsActionTypes.SAVE_CONTENT_SUCCESS,
      pendingContent: json,
      contentSaved: true,
      isFetching: false,
      error: null
    };
  };

  var saveContent = exports.saveContent = function saveContent(tag, content) {
    return function (dispatch, getState) {
      if (!tag || tag === '') dispatch(saveContentFailed('tag not found'));
      dispatch(saveContentRequest());

      try {
        var _getState$cmsDefiniti = getState().cmsDefinition.pendingContent,
            pendingContent = _getState$cmsDefiniti === undefined ? {} : _getState$cmsDefiniti;
        var newContent = Object.assign({}, content);
        var changedPublishedContent = (0, _immutabilityHelper2.default)(pendingContent, _defineProperty({}, tag, {
          $set: newContent
        }));
        dispatch(saveContentSuccess(changedPublishedContent));
      } catch (error) {
        dispatch(saveContentFailed(error));
      }
    };
  };
  /*---------------- Publish changes -------------------*/


  var commitContentRequest = exports.commitContentRequest = function commitContentRequest() {
    return {
      type: _cmsActionTypes.COMMIT_CONTENT_REQUEST,
      isFetching: true,
      contentCommitted: false,
      error: null
    };
  };

  var commitContentFailed = exports.commitContentFailed = function commitContentFailed(error) {
    return {
      type: _cmsActionTypes.COMMIT_CONTENT_FAILURE,
      contentCommitted: false,
      error: error.message
    };
  };

  var commitContentSuccess = exports.commitContentSuccess = function commitContentSuccess() {
    return {
      type: _cmsActionTypes.COMMIT_CONTENT_SUCCESS,
      contentCommitted: true,
      isFetching: false,
      error: null
    };
  };

  var commitContent = exports.commitContent = function commitContent() {
    return function (dispatch) {
      dispatch(commitContentRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + 'pending/publish', {
        method: 'post',
        headers: _interact.Connection.cmuHeaders(),
        body: JSON.stringify({})
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.ok;
      }).then(function () {
        dispatch(commitContentSuccess());
        dispatch(loadPublishedContent());
        dispatch(loadPendingContent());
      }).catch(function (error) {
        return dispatch(commitContentFailed(error));
      });
    };
  };
  /*---------------- Push To Server -------------------*/


  var pushContentRequest = exports.pushContentRequest = function pushContentRequest() {
    return {
      type: _cmsActionTypes.PUSH_CONTENT_REQUEST,
      isFetching: true,
      contentPushed: false,
      error: null
    };
  };

  var pushContentFailed = exports.pushContentFailed = function pushContentFailed(error) {
    return {
      type: _cmsActionTypes.PUSH_CONTENT_FAILURE,
      contentPushed: false,
      error: error.message
    };
  };

  var pushContentSuccess = exports.pushContentSuccess = function pushContentSuccess() {
    return {
      type: _cmsActionTypes.PUSH_CONTENT_SUCCESS,
      contentPushed: true,
      contentSaved: false,
      isFetching: false,
      error: null
    };
  };

  var pushContent = exports.pushContent = function pushContent(contents) {
    return function (dispatch) {
      dispatch(pushContentRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + 'pending/', {
        method: 'POST',
        headers: _interact.Connection.cmuHeaders(),
        body: JSON.stringify(contents)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.ok;
      }).then(function () {
        dispatch(pushContentSuccess());
        dispatch(loadPendingContent());
      }).catch(function (error) {
        return dispatch(pushContentFailed(error));
      });
    };
  };
  /*---------------- Delete Content in Server -------------------*/


  var deleteContentRequest = exports.deleteContentRequest = function deleteContentRequest() {
    return {
      type: _cmsActionTypes.DELETE_CONTENT_REQUEST,
      isFetching: true,
      contentDeleted: false,
      error: null
    };
  };

  var deleteContentFailed = exports.deleteContentFailed = function deleteContentFailed(error) {
    return {
      type: _cmsActionTypes.DELETE_CONTENT_FAILURE,
      contentDeleted: false,
      error: error.message
    };
  };

  var deleteContentSuccess = exports.deleteContentSuccess = function deleteContentSuccess() {
    return {
      type: _cmsActionTypes.DELETE_CONTENT_SUCCESS,
      contentDeleted: true,
      isFetching: false,
      error: null
    };
  };

  var deleteContent = exports.deleteContent = function deleteContent() {
    return function (dispatch) {
      dispatch(deleteContentRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + 'pending/', {
        method: 'DELETE',
        headers: _interact.Connection.cmuHeaders()
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.ok;
      }).then(function () {
        dispatch(deleteContentSuccess());
      }).catch(function (error) {
        return dispatch(deleteContentFailed(error));
      });
    };
  };
  /*---------------- Edit Mode -------------------*/


  var contentEditModeRequest = exports.contentEditModeRequest = function contentEditModeRequest() {
    return {
      type: _cmsActionTypes.EDIT_MODE_CONTENT_REQUEST,
      inEditMode: false,
      isFetching: true,
      error: null
    };
  };

  var contentEditModeSuccess = exports.contentEditModeSuccess = function contentEditModeSuccess(editMode) {
    return {
      type: _cmsActionTypes.EDIT_MODE_CONTENT_SUCCESS,
      inEditMode: editMode,
      isFetching: false,
      error: null
    };
  };

  var setShowOrigin = exports.setShowOrigin = function setShowOrigin(showOrigin) {
    return {
      type: _cmsActionTypes.SHOW_ORIGIN,
      showOrigin: showOrigin
    };
  };

  var setEditMode = exports.setEditMode = function setEditMode(editMode) {
    return function (dispatch) {
      dispatch(contentEditModeRequest());
      dispatch(contentEditModeSuccess(editMode));
    };
  };
  /*---------------- History List updates -------------------*/


  var historyListRequest = exports.historyListRequest = function historyListRequest() {
    return {
      type: _cmsActionTypes.HISTORY_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var historyListFailed = exports.historyListFailed = function historyListFailed(error) {
    return {
      type: _cmsActionTypes.HISTORY_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var historyListSuccess = exports.historyListSuccess = function historyListSuccess(json) {
    return {
      type: _cmsActionTypes.HISTORY_SUCCESS,
      historyList: json,
      isFetching: false,
      error: null
    };
  };

  var fetchHistoryList = exports.fetchHistoryList = function fetchHistoryList() {
    return function (dispatch) {
      dispatch(historyListRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + 'changeset/?headersonly=true', {
        method: 'get',
        headers: _interact.Connection.cmuHeaders()
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(historyListSuccess(json));
      }).catch(function (error) {
        return dispatch(historyListFailed(error));
      });
    };
  };
  /*---------------- History Detail updates -------------------*/


  var historyDetailRequest = exports.historyDetailRequest = function historyDetailRequest() {
    return {
      type: _cmsActionTypes.HISTORY_DETAIL_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var historyDetailFailed = exports.historyDetailFailed = function historyDetailFailed(error) {
    return {
      type: _cmsActionTypes.HISTORY_DETAIL_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var historyDetailSuccess = exports.historyDetailSuccess = function historyDetailSuccess(json) {
    return {
      type: _cmsActionTypes.HISTORY_DETAIL_SUCCESS,
      historyDetail: json,
      isFetching: false,
      error: null
    };
  };

  var fetchHistoryDetail = exports.fetchHistoryDetail = function fetchHistoryDetail(timestamp) {
    return function (dispatch) {
      dispatch(historyDetailRequest());
      return fetch(_interact.Connection.baseUrl('cmscontent') + ('changeset/' + timestamp), {
        method: 'get',
        headers: _interact.Connection.cmuHeaders()
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(historyDetailSuccess(json));
      }).catch(function (error) {
        return dispatch(historyDetailFailed(error));
      });
    };
  };
  /*---------------- RESET History Detail -------------------*/


  var resetHistoryDetail = exports.resetHistoryDetail = function resetHistoryDetail() {
    return {
      type: _cmsActionTypes.HISTORY_DETAIL_RESET,
      isFetching: false,
      error: null,
      historyDetail: null
    };
  };
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _cmsActionTypes = __webpack_require__(0);

  var cmsDefinition = function cmsDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _cmsActionTypes.LOAD_PUBLISHED_CONTENT_SUCCESS:
        return _extends({}, state, {
          publishedContent: action.publishedContent,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.LOAD_PUBLISHED_CONTENT_REQUEST:
      case _cmsActionTypes.LOAD_PUBLISHED_CONTENT_FAILURE:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.LOAD_PENDING_CONTENT_SUCCESS:
        return _extends({}, state, {
          pendingContent: action.pendingContent,
          savedPendingContent: action.pendingContent,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.LOAD_PENDING_CONTENT_REQUEST:
      case _cmsActionTypes.LOAD_PENDING_CONTENT_FAILURE:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.HISTORY_SUCCESS:
        return _extends({}, state, {
          historyList: action.historyList,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.HISTORY_REQUEST:
      case _cmsActionTypes.HISTORY_FAILURE:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.HISTORY_DETAIL_SUCCESS:
        return _extends({}, state, {
          historyDetail: action.historyDetail,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.HISTORY_DETAIL_REQUEST:
      case _cmsActionTypes.HISTORY_DETAIL_FAILURE:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.HISTORY_DETAIL_RESET:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error,
          historyDetail: action.historyDetail
        });

      case _cmsActionTypes.EDIT_CONTENT_SUCCESS:
        return _extends({}, state, {
          contentEdited: action.contentEdited,
          tagEdited: action.tagEdited,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.EDIT_CONTENT_REQUEST:
      case _cmsActionTypes.EDIT_CONTENT_FAILURE:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.SAVE_CONTENT_SUCCESS:
        return _extends({}, state, {
          pendingContent: action.pendingContent,
          contentSaved: action.contentSaved,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.SAVE_CONTENT_REQUEST:
      case _cmsActionTypes.SAVE_CONTENT_FAILURE:
        return _extends({}, state, {
          contentSaved: action.contentSaved,
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.COMMIT_CONTENT_SUCCESS:
        return _extends({}, state, {
          contentCommitted: action.contentCommitted,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.COMMIT_CONTENT_REQUEST:
      case _cmsActionTypes.COMMIT_CONTENT_FAILURE:
        return _extends({}, state, {
          contentCommitted: action.contentCommitted,
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.PUSH_CONTENT_SUCCESS:
        return _extends({}, state, {
          contentPushed: action.contentPushed,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.PUSH_CONTENT_REQUEST:
      case _cmsActionTypes.PUSH_CONTENT_FAILURE:
        return _extends({}, state, {
          contentPushed: action.contentPushed,
          contentSaved: action.contentSaved,
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.DELETE_CONTENT_SUCCESS:
        return _extends({}, state, {
          contentDeleted: action.contentDeleted,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.DELETE_CONTENT_REQUEST:
      case _cmsActionTypes.DELETE_CONTENT_FAILURE:
        return _extends({}, state, {
          contentDeleted: action.contentDeleted,
          pendingContent: {},
          savedPendingContent: null,
          isFetching: action.isFetching,
          error: action.error
        });

      case _cmsActionTypes.SHOW_ORIGIN:
        return _extends({}, state, {
          showOrigin: action.showOrigin
        });

      case _cmsActionTypes.EDIT_MODE_CONTENT_SUCCESS:
        return _extends({}, state, {
          inEditMode: action.inEditMode,
          isFetching: action.isFetching
        });

      case _cmsActionTypes.EDIT_MODE_CONTENT_REQUEST:
        return _extends({}, state, {
          inEditMode: false,
          isFetching: action.isFetching,
          error: action.error
        });

      default:
        return state;
    }
  };

  exports.default = cmsDefinition;
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.cmsDefinition = undefined;

  var _reducer = __webpack_require__(3);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(2);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(1);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.cmsDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("@myie/interact");
  /***/
},
/* 8 */

/***/
function (module, exports) {
  module.exports = require("immutability-helper");
  /***/
}
/******/
]);